import React from 'react';
import styled from 'styled-components';

export const Divider = styled.div`
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.colors.stroke};
  position: absolute;
  left: 0;
`;
